export default "__VITE_ASSET__709d6b85__"